"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkeletonMageTable = void 0;
const LootTable_1 = __importDefault(require("../../../../structures/LootTable"));
const SimpleMonster_1 = __importDefault(require("../../../../structures/SimpleMonster"));
const HerbDropTable_1 = __importDefault(require("../../../subtables/HerbDropTable"));
const RareDropTable_1 = require("../../../subtables/RareDropTable");
exports.SkeletonMageTable = new LootTable_1.default()
    .every('ashes')
    .tertiary(5000, 'Skeleton champion scroll')
    .tertiary(128, 'Clue scroll (medium)')
    //TODO: Check for updated drop rates in future.
    /* Weapons and armour */
    .add('Pink skirt', 1, 8)
    .add('Battlestaff', 1, 1)
    /* Runes */
    .add('Mind rune', [7, 9], 8)
    .add('Chaos rune', [2, 4], 6)
    .add('Law rune', [2, 3], 4)
    .add('Nature rune', [1, 3], 1)
    /* Herbs */
    .add(HerbDropTable_1.default, 1, 4)
    /* Materials */
    .add('Uncut opal', 1, 8)
    .add('Pot of flour', 1, 8)
    .add('Iron bar', [1, 2], 4)
    /* Other */
    .add('Coins', [26, 54], 22)
    .add('Big bones', [3, 4], 1)
    /* Gem drop table */
    .add(RareDropTable_1.GemTable);
exports.default = new SimpleMonster_1.default({
    id: 4319,
    name: 'Skeleton Mage',
    table: exports.SkeletonMageTable,
    aliases: ['skeleton mage']
});
//# sourceMappingURL=SkeletonMage.js.map